<template>
  <div class="home-page cg-page">
		<div class="login-content">
      <div class="pt20 disflex" style="justify-content: center;position: fixed;background:url(static/images/star.png) no-repeat 0 0;max-width:750px;height: 317px;background-size: cover;    align-items: flex-start;">
        <a class="logo" style="width: 150px;margin: 0 30px;" href="/"><img src="static/images/logo1.png" /></a>
      </div>

      <div class="landing-page login">
<!--        <div class="account-top" style="margin: 0;padding: 20px 20px 0;" @click="back()">-->
<!--          <img width="80" src="static/images/retrun.png">-->
<!--        </div>-->
        <div class="">
          <div class="home-prize" style="padding-top: 145px;">
            <div class="home1 ac">
              <img :src="isEN=='bur'?'../../static/images/login-bg4.png':'../../static/images/login-bg4.png'">
            </div>
          </div>
          <div class="drown-list">
            <div class="input-div">
              <div class="span fs26 ac fw7" style="font-weight:700;margin-bottom: 15px;">{{$t('phoneNumber')}}</div>
              <div class="input-item">
<!--                  <span>09</span>-->
                <input style="width: 100%" class="input" readonly type="number" v-model="mobile"  placeholder="">
              </div>
            </div>
            <div class="input-div" style="margin-top: 20px;">
              <div class="span fs33 crfff app-en fw7" style="font-weight: 400;margin-bottom: 15px;">OTP</div>
              <div class="input-item disflex" style="background: none;">
                <input class="input-item input" v-model="otp" type="number" style="width: 100%;height:80px;" placeholder="">
                <button class="btn btn-red" style="padding: 0px 10px;min-height: 50px;line-height: 50px;min-width: 180px;margin-left: 5px;font-size: 20px;border-radius: 10px;font-family: arial;
    text-shadow: 0 0 black;font-weight: 700;text-transform: capitalize;" :class="{disable:codeText != $t('getCode')}" type="none" :disabled="codeText != $t('getCode')" @click="getSendOtp">{{codeText}}</button>
              </div>
            </div>
            <div class="disflex" style="margin-top:20px">
              <div class="drown-li" @click="goLogin()">
                <div class="disflex day" >
                  <span>{{$t('register')}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="footer-content ac" style="justify-content: space-evenly;">
            <div class="icon icon2" @click="getType('faq')">
              <img src="../../static/images/menu-icon5.png" />
              <span>{{$t('FAQs')}}</span>
            </div>
            <div class="icon icon3" @click="getType('termsAndCondition')">
              <img src="../../static/images/menu-icon6.png" />
              <span>{{$t('TC')}}</span>
            </div>
          </div>
        </div>
      </div>
		</div>
	</div>
</template>
<script>
import Header from '../components/headerNo'
export default {
    components:{
		Header
    },
    data() {
      return {
        list:[],
        mobile:'',
        type:'',
        password:'',
        otp:'',
        codeText:'',
        isReturn:false,
        isEN:'bur'

      }
    },
	created(){
    this.codeText = this.$t('getCode')
    if(localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
    if (this.$route.query.msisdn){
      this.mobile = this.$route.query.msisdn
      this.getSendOtp();
    }
	},
    methods: {
      getType(type){
          this.$router.push({path:type,query:{type:type}});
      },
      back(){
        this.$router.go(-1);
      },
      getSendOtp(){
        let that = this
        if(that.isReturn){
          return;
        }
        if (!this.mobile){
          return;
        }
        that.isReturn = true
        let data ={
            'mobile':this.mobile
        }
        that.$parent.loadModal(true);
        that.$api.post('/api/user/send_otp',data,r =>{
          that.$parent.loadModal(false);
          that.$utils.alertText(r.msg,80,3000);
          if (r.code == 1){
            this.countDown(61,1)
          }else{
            that.isReturn = false;
          }
        })
      },
      goLogin(){
        let that = this
        if(that.mobile==''){
        	that.$utils.alertText(that.$t('tips'),60)
        	return;
        }
        let data ={
            'mobile':this.mobile,
            'otp':this.otp,
        }
        that.$parent.loadModal(true);

        let params = new URLSearchParams(this.$route.query);
        let url = '/api/user/otp_login?' + params.toString();
        that.$api.post(url,data,r =>{
          that.$parent.loadModal(false);
          if(r.code==1){
            localStorage.setItem('token',r.data.userinfo.token)
            localStorage.setItem('mobile',r.data.userinfo.mobile)
            that.isShowlogin = false
            that.mobile = ''
            that.otp = ''
            this.$router.push({path:'/'})
          }else{
            that.$utils.alertText(r.msg,80);
          }
          console.log(r.data.userinfo.token)
        })
      },
      // 计时
      countDown (miao,type){
      	if(miao === 1){
      		this.codeText = this.$t('getCode');
      		return;
      	}
      	miao--;
      	if(type === 1){
      		this.codeText = miao + "s";
          this.isReturn = false
      	}
      	setTimeout(() =>{
      		this.countDown(miao,type);
      	},1000)
      }
	}
}
</script>
<style scoped>
  .drop-down-content{z-index:9;background:none;}
  .otp-b{justify-content: space-evenly;}
  .login{margin-top:0px;}

  .btn-red{padding:20px 20px;background: #3bc458;width: auto;height: auto;display: block;margin: 0 auto;font-size:40px;}

  .drop-down-content{z-index:9;background:none;}
  .landing-page{padding-bottom:60px;}
  .cg-page{background: url(../../static/images/bg3-png.jpg) no-repeat center top #0034ae;}
  .input-item{background:url(../../static/images/input-bg.png) no-repeat center center;background-size: contain;height: 102px;width: 474px;display: flex;align-items: center;}
  .input-div div span{color:#0036af;}
  .input-div .input{color:#0036af;}
  .drown-li{margin: 0 auto}
  .drown-bg .drown-li.active::before,.drown-bg .drown-li::before{display: none;}
  .drown-list .disflex{font-size: 30px;font-weight: 700;box-shadow: none;background-color: none;text-shadow: #000000 -5px 2px;    margin-top: -12px;}
  .week{background: url(../../static/images/week.png) no-repeat;width: 60%;background-size: contain;min-height: 140px;width: 401px;height: 327px;margin: 0 auto;}
  .day{justify-content:center;font-size:40px;background: url(../../static/images/login.png) no-repeat;background-size: contain;min-height: 100px;width: 320px;text-shadow: #000000 -5px 2px;}
  .month{background: url(../../static/images/month.png) no-repeat;background-size: contain;min-height: 100px;width: 275px;}
  .lg-bg2{background:url(../../static/images/login-img3.png) no-repeat center 70px;}
</style>



// WEBPACK FOOTER //
// src/page/sendOtp.vue